
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bushireforpunetolonavala() {



    const cardData =
    {
        keyword: 'Bus hire for Pune to Lonavala',
        heading: 'Amruta Travels: Bus hire for Pune to Lonavala',
        headingDescription: 'Amruta Travels offers Bus Hire for Pune to Lonavala, providing a reliable and comfortable transportation solution for your journey to the scenic hill station of Lonavala. Whether you are planning a family outing, corporate retreat, or group tour, our well-maintained buses ensure a smooth and enjoyable ride through the picturesque Western Ghats. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your Lonavala trip simple and stress-free. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. Book your Pune to Lonavala Bus with Amruta Travels and embark on a journey of comfort and discovery!',


        top: 'Top Places to Visit in Lonavala with Amruta Travels',
"topPlaces": [
  {
    "title": "Tiger's Leap (Tiger Point)",
    "description": "Tiger's Leap is a prominent viewpoint located about 8 km from Lonavala. The cliff-top offers a sheer drop of over 650 meters, providing panoramic views of the lush valleys and the Western Ghats. The spot gets its name due to its resemblance to a tiger leaping into the valley. It's especially popular during sunrise and sunset, offering breathtaking vistas. The area also features an echo point, where visitors can hear their voices reverberate through the hills."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is a masonry dam on the Indrayani River, known for its scenic beauty and the gushing water that overflows during the monsoon season. It's a favorite spot for tourists to relax and enjoy the cascading water over the steps. While swimming is prohibited due to safety concerns, visitors often enjoy sitting on the steps and letting the water flow over them. The surrounding area is dotted with food stalls offering local snacks."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort, meaning 'Iron Fort,' is a historic hill fort situated near Lonavala. Perched at an elevation of about 1,033 meters, it offers a relatively easy trek, making it suitable for beginners. The fort is known for its impressive architecture, including the 'Vinchu Kata' (Scorpion's Tail) ramparts. From the top, visitors can enjoy panoramic views of the surrounding hills and the Pawna Lake. The fort holds significant historical importance, having been used by various dynasties, including the Marathas."
  },
  {
    "title": "Karla Caves",
    "description": "The Karla Caves are ancient Buddhist rock-cut caves dating back to the 2nd century BCE. Located near Lonavala, these caves are renowned for their intricate carvings, grand Chaitya (prayer hall), and the impressive stone pillars. The main hall houses a large stupa and features a wooden roof structure that has remarkably survived over centuries. Adjacent to the caves is the Ekvira Devi Temple, attracting both pilgrims and tourists."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic fortification consisting of two twin forts—Shrivardhan and Manaranjan. Nestled amidst the Sahyadri mountains, it's a popular trekking destination, especially during the monsoon when the surroundings are lush green. The trek offers scenic views, waterfalls, and a chance to explore the ancient fort structures. The fort also provides panoramic views of the Kondana Caves and the Ulhas River valley."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is an artificial reservoir formed by the Pawna Dam, located near Lonavala. Surrounded by the scenic Sahyadri ranges, it's a popular spot for camping, picnics, and water activities. The tranquil environment, especially during sunrise and sunset, makes it a favorite among nature enthusiasts. The lake also offers views of nearby forts like Lohagad, Tikona, and Tung."
  },
  {
    "title": "Della Adventure Park",
    "description": "Della Adventure Park is India's largest adventure park, spread over 36 acres in Lonavala. It offers over 50 adventure activities, including bungee jumping, dirt biking, zip-lining, and more. The park also features luxury accommodations, restaurants, and a spa, making it a comprehensive destination for thrill-seekers and families alike."
  },
  {
    "title": "Bhaja Caves",
    "description": "Bhaja Caves are a group of 22 rock-cut caves dating back to the 2nd century BCE. Located near Lonavala, these caves are known for their stupas, intricate carvings, and the impressive Chaitya hall. The caves provide insights into early Buddhist architecture and are set amidst a picturesque backdrop of waterfalls and greenery, especially during the monsoon."
  },
  {
    "title": "Sunil's Celebrity Wax Museum",
    "description": "Sunil's Celebrity Wax Museum in Lonavala showcases lifelike wax statues of various Indian and international celebrities, including political leaders, sports personalities, and film stars. It's a fun and interactive attraction for visitors of all ages, offering numerous photo opportunities."
  },
  {
    "title": "Lion's Point",
    "description": "Lion's Point is a scenic viewpoint located between Bhushi Dam and Aamby Valley. It offers panoramic views of the surrounding valleys, waterfalls, and the Western Ghats. The spot is especially popular during sunrise and sunset, providing breathtaking vistas. Local vendors often set up stalls selling snacks like corn on the cob and tea, enhancing the experience."
  }
],



 "services": [
    {
      "name": "Pune to Lonavala Bus Rental",
      "description": "Amruta Travels offers affordable and reliable bus rental services from Pune to Lonavala. Whether you’re planning a short weekend trip or a day-long getaway, our buses ensure comfort, safety, and a smooth ride through scenic hill roads."
    },
    {
      "name": "Hire a Bus from Pune to Lonavala for Trip",
      "description": "Plan your trip to the serene hill station of Lonavala with Amruta Travels. We offer AC and Non-AC buses for small to large groups, complete with comfortable seating, ample luggage space, and professional drivers for a stress-free travel experience."
    },
    {
      "name": "Pune to Bus Service",
      "description": "Our Pune to Lonavala bus service is ideal for regular travelers, tour organizers, and families seeking convenient transportation. Enjoy punctual departures, courteous drivers, and clean, well-maintained buses for your journey."
    },
    {
      "name": "Pune to Lonavala Tour Bus Rental",
      "description": "Book a tour bus rental from Pune to Lonavala with Amruta Travels for sightseeing and group tours. Our buses are equipped with audio-visual systems, spacious seating, and onboard amenities to make your journey memorable."
    },
    {
      "name": "Pune to Lonavala Family Trip Bus Hire",
      "description": "Make your family trip to Lonavala more enjoyable with our specially designed family bus hire services. Travel together in comfort with AC options, clean interiors, and safety-focused features."
    },
    {
      "name": "Pune to Lonavala Weekend Getaway Bus Rental",
      "description": "Looking for a weekend escape? Rent a bus from Pune to Lonavala with Amruta Travels. Perfect for friends or coworkers, our service ensures a fun, quick, and scenic ride to the hills."
    },
    {
      "name": "Pune to Lonavala Corporate Bus Hire",
      "description": "Amruta Travels provides corporate bus hire services for teams heading to Lonavala for offsite events, workshops, or retreats. Our buses are comfortable, reliable, and perfect for productive and relaxing team outings."
    },
    {
      "name": "Pune to Lonavala Group Travel Bus Rental",
      "description": "Organizing a group tour to Lonavala? Choose Amruta Travels’ group travel buses with various seating capacities, large windows for views, and on-time services to ensure a smooth experience for everyone on board."
    },
    {
      "name": "AC Bus Hire Pune to Lonavala",
      "description": "Beat the heat and travel in comfort with our AC bus hire services from Pune to Lonavala. These buses are ideal for all types of trips, including corporate outings, school trips, and family vacations."
    },
    {
      "name": "Comfortable Bus From Pune to Lonavala",
      "description": "Travel in style and comfort with Amruta Travels’ fleet of well-equipped buses for your journey from Pune to Lonavala. Our buses feature push-back seats, ample legroom, and smooth suspension systems for a relaxing ride."
    },
    {
      "name": "25-Seater Bus Hire Pune to Lonavala",
      "description": "Our 25-seater buses are perfect for mid-sized groups heading from Pune to Lonavala. With AC and Non-AC options, these buses come with reclining seats, luggage storage, and expert drivers familiar with the route."
    },
    {
      "name": "32-Seater Bus Hire from Pune to Lonavala",
      "description": "Hire a spacious 32-seater bus for your next Lonavala trip. Amruta Travels provides well-maintained vehicles that are ideal for school outings, large families, or business groups looking for a comfortable journey."
    },
    {
      "name": "50-Seater Bus Hire from Pune to Lonavala",
      "description": "For large groups and corporate outings, our 50-seater bus rentals from Pune to Lonavala provide a safe, comfortable, and economical travel solution. Book now for a seamless group journey to the hills."
    },
    {
      "name": "Pune to Lonavala Bus Tour Package",
      "description": "Explore the best of Lonavala with our customized bus tour packages from Pune. These packages include transport, sightseeing schedules, and professional guides to make your trip informative and enjoyable."
    },
    {
      "name": "Pune to Lonavala Khandala Bus Hire",
      "description": "Make the most of your trip by covering both Lonavala and Khandala with our combined bus hire services. Our vehicles are ideal for full-day sightseeing, weekend getaways, and educational tours."
    }
  ],
  "tableData": [
    ["Pune to Lonavala Bus Rental", "Hire a Bus from Pune to Lonavala for Trip"],
    ["Pune to Bus Service", "Pune to Lonavala Tour Bus Rental"],
    ["Pune to Lonavala Family Trip Bus Hire", "Pune to Lonavala Weekend Getaway Bus Rental"],
    ["Pune to Lonavala Corporate Bus Hire", "Pune to Lonavala Group Travel Bus Rental"],
    ["AC Bus Hire Pune to Lonavala", "Comfortable Bus From Pune to Lonavala"],
    ["25-Seater Bus Hire Pune to Lonavala", "32-Seater Bus Hire from Pune to Lonavala"],
    ["50-Seater Bus Hire from Pune to Lonavala", "Pune to Lonavala Bus Tour Package"],
    ["Pune to Lonavala Khandala Bus Hire", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Convenient and Comfortable Bus Hire for Pune to Lonavala",
    "WhyChoosedescription": "Amruta Travels offers reliable bus hire services for travel from Pune to Lonavala, one of Maharashtra’s most popular hill stations. Whether it’s a family trip, corporate outing, or school excursion, our buses provide the perfect solution for a comfortable and hassle-free ride. Enjoy the scenic beauty of Lonavala as you travel in comfort, with a range of bus options to suit every group size."
  },
  {
    "WhyChooseheading": "Perfect for Weekend Getaways and Sightseeing Tours",
    "WhyChoosedescription": "Lonavala, with its scenic views, lush greenery, and popular tourist spots like Bhushi Dam, Tiger’s Leap, and Karla Caves, is the perfect weekend destination from Pune. Our bus hire service ensures that your group can experience a stress-free journey, whether you’re visiting for a day trip or planning a weekend getaway. We offer flexible schedules to fit your itinerary and provide safe, enjoyable travel to and from Lonavala."
  },
  {
    "WhyChooseheading": "Variety of Bus Sizes to Suit All Group Sizes",
    "WhyChoosedescription": "We offer a range of buses for hire, from smaller 17-seater vehicles to larger 50-seater buses. Depending on the size of your group, we ensure the perfect fit, with ample legroom, comfortable seating, air-conditioning (or Non-AC, as per your preference), and sufficient luggage space for your travel essentials. Whether you’re a small family, a large corporate group, or a school tour, we’ve got you covered."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our drivers are experienced and well-versed in the routes from Pune to Lonavala. They ensure safe, timely, and smooth travel while navigating the scenic but winding roads of the Western Ghats. They are also well-acquainted with popular stopovers along the route, allowing for breaks or photo opportunities on your journey, ensuring a pleasant and comfortable trip for all passengers."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing Structure",
    "WhyChoosedescription": "At Amruta Travels, we offer competitive pricing with a transparent structure for your Pune to Lonavala bus hire. No hidden costs! The quoted price includes everything from fuel and toll charges to driver fees and taxes. We ensure that the cost is reasonable, giving you an affordable and hassle-free experience while sticking to your budget."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses for a Comfortable Journey",
    "WhyChoosedescription": "All our buses are regularly maintained and cleaned to ensure maximum comfort and safety. We prioritize hygiene, especially for long trips, so you can travel with peace of mind. With reclining seats, spacious interiors, and well-functioning air-conditioning, our buses are designed to make your Pune to Lonavala trip as relaxing as possible."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Flexible Travel Plans",
    "WhyChoosedescription": "We understand that each group has unique needs. Whether you want to plan a single-day trip, a weekend getaway, or extend your stay in Lonavala, our itineraries are fully customizable. We also offer the flexibility of multiple pickup points in Pune, tailored routes, and optional stopovers at popular tourist spots along the way."
  },
  {
    "WhyChooseheading": "Simple Booking Process with Full Support",
    "WhyChoosedescription": "Booking a bus for your Pune to Lonavala trip is simple and hassle-free with Amruta Travels. You can easily reserve your bus through our website, by calling our customer support team, or visiting our office. Our team is always available to answer questions, make adjustments to your booking, or assist you with any travel-related concerns, ensuring a smooth journey from start to finish."
  }
]















    }

const faqData = [
  {
    question: 'How can I hire a bus from Pune to Lonavala?',
    answer: 'Hiring a bus from Pune to Lonavala with Amruta Travels is simple. You can book through our website, call our customer support, or visit our office. We assist you in selecting the right bus based on your group size and travel preferences.',
  },
  {
    question: 'What types of buses are available for Pune to Lonavala travel?',
    answer: 'We offer a wide range of buses including 32, 35, 40, 45, and 50-seater AC and non-AC options. Luxury buses with reclining seats and modern amenities are also available for a more premium experience.',
  },
  {
    question: 'Is the Pune to Lonavala route suitable for a day trip?',
    answer: 'Yes, Lonavala is a perfect destination for a day trip from Pune. The journey takes around 2 to 2.5 hours one way, making it ideal for school picnics, corporate outings, or family getaways.',
  },
  {
    question: 'Do you offer round-trip bus services to Lonavala?',
    answer: 'Yes, we offer both one-way and round-trip services. You can plan a same-day return or stay overnight and schedule your return the next day as per your convenience.',
  },
  {
    question: 'What amenities are available in the buses for the Lonavala trip?',
    answer: 'Our buses are equipped with push-back seats, air conditioning (for AC models), ample luggage space, music systems, and clean interiors to ensure a comfortable travel experience.',
  },
  {
    question: 'Can I customize the itinerary for a Lonavala trip?',
    answer: 'Absolutely! You can customize the pickup and drop points, travel times, and sightseeing schedule. Whether it’s a visit to Bhushi Dam, Tiger’s Leap, or Lonavala Lake, we’ll tailor the trip accordingly.',
  },
  {
    question: 'Is food allowed on the bus during the trip?',
    answer: 'Yes, you may carry food and beverages on board. We also plan halts at clean restaurants along the way for meals and refreshments.',
  },
  {
    question: 'What are the charges for hiring a bus from Pune to Lonavala?',
    answer: 'The charges depend on the bus type, number of passengers, and duration of the trip. Contact us with your travel details for a transparent and customized quote.',
  },
  {
    question: 'Why choose Amruta Travels for a Pune to Lonavala bus trip?',
    answer: 'Amruta Travels offers safe, reliable, and comfortable transportation with experienced drivers and well-maintained buses. We focus on punctuality and customer satisfaction for every journey.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rohit Gokhale',
    role: 'Corporate Event Organizer, Pune',
    text: 'We hired a 45-seater bus from Amruta Travels for our company’s Lonavala day trip. Everything was smooth — the bus arrived on time, was very clean, and the driver was cooperative. Great experience!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rutuja Mehta',
    role: 'School Teacher, Pune',
    text: 'We arranged a school picnic to Lonavala and Amruta Travels provided excellent service. The kids were comfortable and safe. The entire journey was well-managed. Will book again!',
    rating: 5,
  },
];






























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-lonavala-bus.jpg",
  "description": "Book buses from Pune to Lonavala for family trips, corporate outings, or weekend getaways. Choose from 25, 32, or 50-seater buses with AC and comfortable seating for a smooth journey. Enjoy a memorable trip with Amruta Travels for your Lonavala and Khandala visit.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3150"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999", // Adjust price as needed
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-lonavala-bus-hire"
  }
};








    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Lonavala Bus Hire | Weekend Getaway, Corporate & Group Travel | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses for trips from Pune to Lonavala for family vacations, corporate outings, and weekend getaways. Choose from 25, 32, 50-seater AC buses for a comfortable and affordable journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/53.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bushireforpunetolonavala;